(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '[data-text-block-read-more]';

    const getLineHeight = (element) => {
      if (!element) return 24;

      const styles = window.getComputedStyle(element);
      let lineHeight = parseFloat(styles.lineHeight);

      if (Number.isNaN(lineHeight)) {
        const fontSize = parseFloat(styles.fontSize) || 16;
        lineHeight = fontSize * 1.2;
      }

      return lineHeight;
    };

    const setupReadMore = (wrapper) => {
      if (!wrapper) return;

      const content = wrapper.querySelector('[data-text-block-read-more-content]');
      const inner = content?.firstElementChild;
      const button = wrapper.querySelector('[data-text-block-read-more-button]');

      if (!content || !inner || !button) return;

      const lines = parseInt(wrapper.dataset.lines || '3', 10);
      const moreLabel = wrapper.dataset.moreLabel || 'Ler mais';
      const lessLabel = wrapper.dataset.lessLabel || 'Ler menos';

      const probe =
        inner.querySelector('p, h1, h2, h3, h4, h5, h6, li, span, div') || inner;

      const lineHeight = getLineHeight(probe);
      const collapsedHeight = Math.max(lineHeight * lines, 0);
      const fullHeight = inner.scrollHeight;
      const hasOverflow = fullHeight > collapsedHeight + 4;
      const isExpanded = wrapper.classList.contains('is-expanded');

      if (!hasOverflow) {
        content.style.maxHeight = 'none';
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
        button.textContent = lessLabel;
        return;
      }

      button.hidden = false;
      content.style.maxHeight = isExpanded ? `${fullHeight}px` : `${collapsedHeight}px`;
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      button.textContent = isExpanded ? lessLabel : moreLabel;
    };

    const initReadMore = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach(setupReadMore);
    };

    if (!window.__textBlockReadMoreBound) {
      window.__textBlockReadMoreBound = true;

      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-text-block-read-more-button]');
        if (!button) return;

        const wrapper = button.closest(SELECTOR);
        if (!wrapper) return;

        wrapper.classList.toggle('is-expanded');
        setupReadMore(wrapper);
      });

      document.addEventListener('DOMContentLoaded', () => {
        initReadMore(document);
      });

      window.addEventListener('resize', () => {
        initReadMore(document);
      });

      document.addEventListener('shopify:section:load', (event) => {
        initReadMore(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        initReadMore(event.target);
      });
    }

    initReadMore(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
